export const productPage = {
    init: function () {
        $('select#ledigingsfrequentie, select#aantal').on('change', function() {
            $(this).closest('form').find('button[type="submit"]').attr('disabled', true);
        })
    },
};
